import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IInvitation } from '@app/models/signup';
import { ConfigService } from '@infomaniak/angular-common';
import { InvitationB2bPartnerService } from '../../invitation-b2b-partner.service';

@Component({
  selector: 'app-invitation-b2b-only-for-owner',
  templateUrl: './invitation-b2b-only-for-owners.component.html',
  styleUrls: ['./invitation-b2b-only-for-owners.component.scss']
})
export class InvitationB2bOnlyForOwnersComponent implements OnInit {
  @Output() invitationResent = new EventEmitter();
  @Input() invitation: IInvitation;

  endpoints = window['ENDPOINTS'];
  account = window['CURRENT_ACCOUNT'];
  user = window['CONST_USER'];
  managerLink: string;
  loading = false;
  constructor(
    private router: Router,
    private invitationB2bPartnerService: InvitationB2bPartnerService,
    private configService: ConfigService,
  ) { }

  ngOnInit(): void {
    this.managerLink = `${this.endpoints?.manager}/v3/${this.account.id}/ng/accounts/reseller-space/manage-clients`;
  }

  changeAccount(): void {
    // window.location.assign('auth/logout?with_login_redirect=1&redirect=' + window?.['ENDPOINTS']?.initial);
    this.router.navigate(['/change_account']);
  }

  resendInvitation(): void {
    this.loading = true;
    this.invitationB2bPartnerService.resendInvitation()
      .then((response) => {
        this.invitationResent.emit();
      }).catch((error) => {
        this.configService.displayErrors(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
